import React from 'react';

import classNames from "classnames";
import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {DescriptionHeaderViewModel} from "../../description-header/models/description-header.view-model";
import {FollowSelectionButton} from "./follow-selection-button";
import {PopularityRank} from "../../popularity-rank/popularity-rank";


export class DescriptionHeaderFollowProps extends BaseProps {
  entity: DescriptionHeaderViewModel;
}

export const FollowSelection = ({
                                  size,
                                  color,
                                  descriptionEntity,
                                  containerClassName,
                                  followClassName,
                                  followActiveClassName,
                                  popularityClassName,
                                }: DescriptionHeaderFollowProps) => {
  if(descriptionEntity?.entity === null) {
    return null
  }

  const followProps = {
    className: classNames(followClassName),
    activeClassName: classNames(followActiveClassName),
    id: descriptionEntity?.id,
    extraIds: descriptionEntity?.extraIds,
    type: descriptionEntity?.objectType,
  }

  const popularityRankProps = {
    color,
    size,
    shouldRenderPopularityRank: descriptionEntity.shouldRenderPopularityRank,
    popularityRankText: (descriptionEntity?.popularityRank)?.shortNumber(),
    className: classNames(popularityClassName)
  };

  return (
    <div className={classNames(containerClassName)}>
      <FollowSelectionButton {...followProps}/>
      <PopularityRank {...popularityRankProps}/>
    </div>
  )
}
